<template>
  <div class="assessment-input">
    <p>请选择，最多 {{ maxSelections }} 项</p>
    <OptionList :value="value" :options="options" multiple :disabled="disabled" :disabled-options="disabledOptions" @input="update" />
  </div>
</template>
<script>
import OptionList from './OptionList.vue'
export default { name: 'AssessmentQuestionInput', components: { OptionList }, props: { value: { type: Array, default: () => [] }, options: { type: Array, default: () => [] }, maxSelections: { type: Number, default: 1 }, disabled: { type: Boolean, default: false } }, computed: { disabledOptions() { if (this.value.length < this.maxSelections) return []; return this.options.filter(item => !this.value.includes(item.key)).map(item => item.key) } }, methods: { update(next) { this.$emit('input', next.slice(0, this.maxSelections)) } } }
</script>
<style scoped lang="scss">@import '@/styles/tokens'; .assessment-input { display: grid; gap: 8px; } p { margin: 0; color: $color-text-secondary; font-size: 13px; }</style>
